import {serializable, alias, primitive} from 'serializr';

export class User {
    @serializable(alias('id', primitive()))
    id?: string;
    @serializable(alias('institute_id', primitive()))
    instituteId?: string;
    @serializable(alias('email', primitive()))
    email?: string;
    @serializable(alias('first_name', primitive()))
    firstName?: string;
    @serializable(alias('last_name', primitive()))
    lastName?: string;
    @serializable(alias('phone_number', primitive()))
    phoneNumber?: string;
    @serializable(alias('full_name', primitive()))
    fullName?: string;
    @serializable(alias('role_name', primitive()))
    roleName?: string;
    @serializable(alias('display_picture_url', primitive()))
    displayPictureUrl?: string;
}
